<template>
  <div class="main">
    <div class="content">
      <div class="join-left one">
        <div class="shade">
          <h2>加盟须知</h2>
          <p class="underline"></p>
          <p class="join-p">Affiliate Policy</p>
        </div>
      </div>
      <div class="join-right">
        <pre>{{ value.instructions }}</pre>
      </div>
    </div>
    <div class="content">
      <div class="join-left two">
        <div class="shade">
          <h2>加盟条件</h2>
          <p class="underline"></p>
          <p class="join-p">Join Conditions</p>
        </div>
      </div>
      <div class="join-right">
        <pre>{{ value.conditions }}</pre>
      </div>
    </div>
    <div class="content">
      <div class="join-left three">
        <div class="shade">
          <h2>加盟程序</h2>
          <p class="underline"></p>
          <p class="join-p">Join Process</p>
        </div>
      </div>
      <div class="join-right">
        <pre>{{ value.process }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: {},
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  .content {
    // display: flex;
    height: 333px;
    background: #fff;
    margin-bottom: 36px;
    .join-left {
      width: 252px;
      height: 333px;
      background-repeat: no-repeat;
      background-size: cover;
      float: left;

      .shade {
        background-color: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        h2 {
          font-size: 30px;
          font-weight: 500;
          color: #fff;
          margin-left: 48px;
        }
        .underline {
          width: 24px;
          height: 2px;
          background: #fff;
          margin: 36px 48px 41px;
        }
        .join-p {
          font-size: 23px;
          color: #fff;
          margin-left: 48px;
        }
      }

      &.one {
        background-image: url(../../assets/join/join-bg-1.jpg);
      }
      &.two {
        background-image: url(../../assets/join/join-bg-2.jpg);
      }
      &.three {
        background-image: url(../../assets/join/join-bg-3.jpg);
      }
    }
    .join-right {
      padding-left: 48px;
      display: flex;
      padding: 40px 50px;

      pre {
        font-size: 16px;
        line-height: 25px;
        color: #555555;
        word-break: break-all;
        white-space: pre-line;
      }
    }
  }
  .content:last-child {
    margin-bottom: 0;
  }
}
</style>
